import { FormattedMessage } from "react-intl";

import { KibelaModal } from "~/client/components/KibelaModal";

interface Props {
  isAddModalOpen: boolean;
  isSubmitting: boolean;
  emojiCode: string;
  imageDataUrl: string;
  imageFileName: string;

  setIsAddModalOpen(isOpen);
  setEmojiCode(emojiCode);
  onChangeImage(e);
  onSubmit(ev: React.FormEvent);
}

export const CustomEmojiAddModal: React.FC<Props> = (props) => {
  return (
    <KibelaModal
      contentLabel="Custom Emoji Registration Modal"
      isOpen={props.isAddModalOpen}
      overlayClassName="modal-overlay"
      className="modal-container customEmoji-addModal"
      onRequestClose={() => props.setIsAddModalOpen(false)}
      shouldCloseOnOverlayClick={false}
    >
      <h4 className="customEmoji-addModal-header">
        <FormattedMessage id="customEmoji.addition" />
      </h4>
      <form className="customEmojiForm" onSubmit={props.onSubmit}>
        <div className="form-fieldWrapper">
          <label>
            <FormattedMessage id="customEmoji.image" />
          </label>
          <div>
            <span className="customEmojiForm-selectImage">
              <FormattedMessage id="customEmoji.selectImage" />
              <input
                accept="image/png,image/jpeg,image/gif"
                type="file"
                className="customEmojiForm-selectImageField"
                onChange={props.onChangeImage}
                disabled={props.isSubmitting}
              />
            </span>
            <div className="form-comment">
              <FormattedMessage id="customEmoji.imageDescription" />
            </div>
          </div>
          {props.imageDataUrl && (
            <div className="customEmojiForm-preview">
              <img className="customEmojiForm-preview-image" src={props.imageDataUrl} />
              <div>{props.imageFileName}</div>
            </div>
          )}
        </div>

        <div className="form-fieldWrapper">
          <label>
            <FormattedMessage id="customEmoji.code" />
          </label>
          <div className="customEmojiForm-code">
            <span className="customEmojiForm-codeColon">:</span>
            <input
              type="text"
              className="customEmojiForm-codeField"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              placeholder="emoji_code"
              value={props.emojiCode}
              maxLength={50}
              onChange={(e) => props.setEmojiCode(e.target.value)}
              disabled={props.isSubmitting}
            />
            <span className="customEmojiForm-codeColon">:</span>
          </div>
          <div className="form-comment">
            <FormattedMessage id="customEmoji.codeDescription" />
          </div>
        </div>

        <div className="customEmoji-addModal-footer">
          <button type="button" className="button" onClick={() => props.setIsAddModalOpen(false)}>
            <FormattedMessage id="shared.cancel" />
          </button>
          <button
            type="submit"
            className="button is-button-attention"
            disabled={!(props.emojiCode && props.imageDataUrl) || props.isSubmitting}
          >
            <FormattedMessage id="customEmoji.add" />
          </button>
        </div>
      </form>
    </KibelaModal>
  );
};
